import React from "react";
import "./compliance.css";

import {
  AlertTriangle,
  XCircle
} from "lucide-react";

import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer
} from "recharts";


export default function ComplianceDashboard() {

  const frameworks = [
    {
      name: "eIDAS (EU)",
      score: "95%",
      controls: "58 / 61",
      last: "May 15, 2024",
      review: "Aug 15, 2024"
    },
    {
      name: "GDPR (EU)",
      score: "93%",
      controls: "72 / 78",
      last: "May 14, 2024",
      review: "Aug 14, 2024"
    },
    {
      name: "NIST CSF 2.0",
      score: "90%",
      controls: "45 / 50",
      last: "May 14, 2024",
      review: "Aug 14, 2024"
    },
    {
      name: "FIPS 140-2",
      score: "92%",
      controls: "28 / 30",
      last: "May 13, 2024",
      review: "Aug 14, 2024"
    },
    {
      name: "ISO 27001:2022",
      score: "91%",
      controls: "62 / 68",
      last: "May 13, 2024",
      review: "Aug 13, 2024"
    },
    {
      name: "DPIA (All India)",
      score: "89%",
      controls: "47 / 53",
      last: "May 13, 2024",
      review: "Aug 13, 2024"
    }
  ];

  const chartData = [
    { name: "Passed", value: 312 },
    { name: "Risk", value: 14 },
    { name: "Failed", value: 8 },
    { name: "NA", value: 6 }
  ];

  const COLORS = [
    "#16a34a",
    "#f59e0b",
    "#ef4444",
    "#64748b"
  ];

  return (
    <div className="compliance-page">
      <div className="stats-row">
        <div className="score-card">
          <p className="card-title">Overall Compliance Score</p>
          <div className="score-content">
            <div className="score-left">
              <h3>92%</h3>
              <span>Compliant</span>
            </div>
            <div className="progress-ring">
              <svg width="70" height="70" viewBox="0 0 72 72">
                <circle cx="36" cy="36" r="24" stroke="#E5E7EB" strokeWidth="8" fill="none" />
                <circle cx="36" cy="36" r="24" stroke="#16A34A" strokeWidth="8" fill="none" strokeLinecap="round" strokeDasharray="151" strokeDashoffset="12" transform="rotate(-90 36 36)" />
              </svg>
            </div>
          </div>
        </div>
        <div className="stat-card">
          <p>Total Frameworks</p>
          <h1>6</h1>
          <span className="green">● Active</span>
        </div>
        <div className="stat-card">
          <p>Passed Controls</p>
          <h1>312 / 340</h1>
          <span className="green">91.8%</span>
        </div>
        <div className="stat-card orange">
          <p>At Risk Controls</p>
          <h1>14</h1>
          <span>4.1%</span>
        </div>
        <div className="stat-card red">
          <p>Failed Controls</p>
          <h1>8</h1>
          <span>2.4%</span>
        </div>
        <div className="stat-card">
          <p>Upcoming Audits</p>
          <h1>3</h1>
          <span>Next: May 30, 2024</span>
        </div>
      </div>
      <div className="main-grid">
        <div className="card framework-card">
          <h3>Compliance Frameworks</h3>
          <table>
            <thead>
              <tr>
                <th>Framework</th>
                <th>Status</th>
                <th>Score</th>
                <th>Controls</th>
                <th>Last Assessed</th>
                <th>Review</th>
              </tr>
            </thead>
            <tbody>
              {frameworks.map((f) => (
                <tr key={f.name}>
                  <td>{f.name}</td>
                  <td><span className="status">Compliant</span></td>
                  <td>{f.score}</td>
                  <td>{f.controls}</td>
                  <td>{f.last}</td>
                  <td>{f.review}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <a href="#all-frameworks">View all frameworks →</a>
        </div>
        <div className="right-section">
          <div className="card chart-card">
            <h3>Compliance Posture</h3>
            <div className="posture-layout">
              <div className="donut">
                <ResponsiveContainer width="100%" height={170}>
                  <PieChart>
                    <Pie data={chartData} innerRadius={55} outerRadius={82} dataKey="value" startAngle={90} endAngle={-270}>
                      {chartData.map((d, i) => (
                        <Cell key={d.name} fill={COLORS[i]} />
                      ))}
                    </Pie>
                  </PieChart>
                </ResponsiveContainer>
                <div className="center-text">
                  <h2>340</h2>
                  <p>Total Controls</p>
                </div>
              </div>
              <div className="legend">
                {chartData.map((d, i) => (
                  <p key={d.name}>
                    <span style={{ backgroundColor: COLORS[i] }}></span>
                    {d.value} {d.name}
                  </p>
                ))}
              </div>
            </div>
          </div>
          <div className="card alerts">
            <h3>Recent Compliance Alerts</h3>
            <div>
              <AlertTriangle size={13} />
              <span>Data retention policy update required</span>
              <span>GDPR</span>
              <span>May 15, 2024</span>
            </div>
            <div>
              <AlertTriangle size={13} />
              <span>Access review pending for 12 users</span>
              <span>ISO 27001</span>
              <span>May 14, 2024</span>
            </div>
            <div>
              <XCircle size={13} />
              <span>Encryption key rotation due</span>
              <span>FIPS 140-2</span>
              <span>May 13, 2024</span>
            </div>
            <a href="#all-alerts">View all alerts →</a>
          </div>
        </div>
      </div>
    </div>
  );
}